import { render } from "./CodeCoveragePage.vue?vue&type=template&id=f5dbd09a&scoped=true"
import script from "./CodeCoveragePage.vue?vue&type=script&lang=js"
export * from "./CodeCoveragePage.vue?vue&type=script&lang=js"

import "./CodeCoveragePage.vue?vue&type=style&index=0&id=f5dbd09a&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5dbd09a"]])

export default __exports__